// Terms of Service 页面相关的翻译资源
export const termsOfServiceResources = {
  zh: {
    // Terms of Service page
    "termsOfService.content": `更新于2025年11月20日

在使用本网站之前，请仔细阅读这些使用条款。

**这些条款包含什么内容？**

这些条款告诉您使用我们网站 <http://www.genovationfoundation.org> 的规则。

**我们是谁以及如何联系我们**

<http://www.genovationfoundation.org> 是由创生基金有限公司运营的网站。  
创生基金是一个平台，旨在通过三个关键途径探索解决方案：经济补贴、政策研究支持和文化倡导。  
如需联系我们，请发送电子邮件至 [info@genovationfoundation.org](mailto:info@genovationfoundation.org)

**使用我们的网站即表示您接受这些条款**

使用我们的网站，即表示您确认接受这些条款并同意遵守这些条款。  
如果您不同意这些条款，则不得使用我们的网站。  
我们可能会不时修订这些条款。我们将在这些条款的顶部注明最后修订日期，任何修订将在发布后生效。

**我们可能会暂停或撤回我们的网站**

我们不保证我们的网站或其上的任何内容将始终可用或不受干扰。出于业务和运营原因，我们可能会暂停、撤回或限制我们网站的全部或任何部分的可用性。我们将尽力就任何暂停或撤回向您发出合理通知。

**您如何使用我们网站上的材料**

我们是我们网站以及网站上发布的材料的所有知识产权的所有者或被许可人。这些作品受世界各地版权法律和条约的保护。所有此类权利均予保留。  
您可以打印一份副本，并可以下载我们网站任何页面的摘录供您个人使用，您也可以让您组织内的其他人注意我们网站上发布的内容。  
您不得以任何方式修改您已打印或下载的任何材料的纸质或数字副本，并且您不得将任何插图、照片、视频或音频序列或任何图形与任何随附文本分开使用。  
必须始终承认我们（以及任何已识别的贡献者）作为我们网站内容作者的身份。  
未经我们许可，您不得将我们网站上的任何内容用于商业目的。  
如果您违反这些条款打印、复制、下载、分享或重新发布我们网站的任何部分，您使用我们网站的权利将立即终止，您必须根据我们的选择，归还或销毁您制作的任何材料副本（但允许您打印这些条款的副本）。

**关于链接到我们网站的规则**

您可以链接到我们的主页，前提是您以公平合法的方式进行，且不损害我们的声誉或利用我们的声誉。  
您不得以暗示我们存在任何形式的关联、批准或认可（实际上并不存在）的方式建立链接。  
您不得在非您拥有的任何网站上建立指向我们网站的链接。  
我们的网站不得在任何其他网站上以框架形式显示，您也不得创建指向我们网站除主页以外的任何部分的链接。  
我们保留在不通知的情况下撤回链接许可的权利。

**我们对链接到的网站不承担责任**

如果我们的网站包含指向第三方提供的其他网站和资源的链接，这些链接仅供您参考。此类链接不应被解释为我们对您可能从这些链接网站获得的信息的批准。  
我们无法控制这些网站或资源的内容。

**我们对病毒不承担责任**

我们不保证我们的网站安全或无错误或病毒。  
您有责任配置您的信息技术、计算机程序和平台以访问我们的网站。您应使用自己的病毒防护软件。

**您不得引入病毒**

您不得通过故意引入病毒、特洛伊木马、蠕虫、逻辑炸弹或其他恶意或技术上有害的材料，或以其他方式有害地与我们的网站或其任何部分交互来滥用我们的网站。您不得试图未经授权访问我们的网站、存储我们网站的服务器或连接到我们网站的任何服务器、计算机或数据库，或连接到我们网站的任何其他设备或网络。您不得干扰、损坏或破坏用于提供我们网站的任何软件，或本网站所依赖的任何第三方拥有或使用的任何设备、网络或软件。您不得通过拒绝服务攻击或分布式拒绝服务攻击攻击我们的网站。

**我们对您遭受的损失或损害的责任**

- 在法律不允许的情况下，我们不会以任何方式排除或限制我们对您的责任。
- 我们排除所有可能适用于我们网站或其上任何内容的默示条件、保证、陈述或其他条款。
- 对于因以下原因产生或与之相关的任何损失或损害，无论是否可预见，无论是合同、违反法定义务还是其他原因，我们均不对您承担责任：
  - 使用或无法使用我们的网站；或
  - 使用或依赖我们网站上显示的任何内容。
- 特别是，我们不对以下情况承担责任：
  - 利润、销售、业务或收入的损失；
  - 业务中断；
  - 预期储蓄的损失；
  - 商业机会、商誉或声誉的损失；或
  - 任何间接或后果性损失或损害。

**我们如何使用您的个人信息**

我们只会按照我们在 <http://www.genovationfoundation.org/privacy-policy> 的隐私声明中的规定使用您的个人信息。

**哪些国家的法律适用于任何争议？**

这些条款、其主题事项及其形成（以及任何非合同争议或索赔）受香港特别行政区法律管辖。我们双方同意香港特别行政区法院的专属管辖权。
    `,
  },
  zh_TW: {
    // Terms of Service page
    "termsOfService.content": `更新於2025年11月20日

在使用本網站之前，請仔細閱讀這些使用條款。

**這些條款包含什麼內容？**

這些條款告訴您使用我們網站 <http://www.genovationfoundation.org> 的規則。

**我們是誰以及如何聯繫我們**

<http://www.genovationfoundation.org> 是由創生基金有限公司營運的網站。  
創生基金是一個平台，旨在透過三個關鍵途徑探索解決方案：經濟補貼、政策研究支持和文化倡導。  
如需聯繫我們，請發送電子郵件至 [info@genovationfoundation.org](mailto:info@genovationfoundation.org)

**使用我們的網站即表示您接受這些條款**

使用我們的網站，即表示您確認接受這些條款並同意遵守這些條款。  
如果您不同意這些條款，則不得使用我們的網站。  
我們可能會不時修訂這些條款。我們將在這些條款的頂部註明最後修訂日期，任何修訂將在發布後生效。

**我們可能會暫停或撤回我們的網站**

我們不保證我們的網站或其上的任何內容將始終可用或不受干擾。出於業務和營運原因，我們可能會暫停、撤回或限制我們網站的全部或任何部分的可用性。我們將盡力就任何暫停或撤回向您發出合理通知。

**您如何使用我們網站上的材料**

我們是我們網站以及網站上發布的材料的所有知識產權的所有者或被許可人。這些作品受世界各地版權法律和條約的保護。所有此類權利均予保留。  
您可以列印一份副本，並可以下載我們網站任何頁面的摘錄供您個人使用，您也可以讓您組織內的其他人注意我們網站上發布的內容。  
您不得以任何方式修改您已列印或下載的任何材料的紙質或數位副本，並且您不得將任何插圖、照片、影片或音訊序列或任何圖形與任何隨附文字分開使用。  
必須始終承認我們（以及任何已識別的貢獻者）作為我們網站內容作者的身分。  
未經我們許可，您不得將我們網站上的任何內容用於商業目的。  
如果您違反這些條款列印、複製、下載、分享或重新發布我們網站的任何部分，您使用我們網站的權利將立即終止，您必須根據我們的選擇，歸還或銷毀您製作的任何材料副本（但允許您列印這些條款的副本）。

**關於連結到我們網站的規則**

您可以連結到我們的首頁，前提是您以公平合法的方式進行，且不損害我們的聲譽或利用我們的聲譽。  
您不得以暗示我們存在任何形式的關聯、批准或認可（實際上並不存在）的方式建立連結。  
您不得在非您擁有的任何網站上建立指向我們網站的連結。  
我們的網站不得在任何其他網站上以框架形式顯示，您也不得建立指向我們網站除首頁以外的任何部分的連結。  
我們保留在不通知的情況下撤回連結許可的權利。

**我們對連結到的網站不承擔責任**

如果我們的網站包含指向第三方提供的其他網站和資源的連結，這些連結僅供您參考。此類連結不應被解釋為我們對您可能從這些連結網站獲得的資訊的批准。  
我們無法控制這些網站或資源的內容。

**我們對病毒不承擔責任**

我們不保證我們的網站安全或無錯誤或病毒。  
您有責任配置您的資訊技術、電腦程式和平台以存取我們的網站。您應使用自己的病毒防護軟體。

**您不得引入病毒**

您不得透過故意引入病毒、特洛伊木馬、蠕蟲、邏輯炸彈或其他惡意或技術上有害的材料，或以其他方式有害地與我們的網站或其任何部分互動來濫用我們的網站。您不得試圖未經授權存取我們的網站、儲存我們網站的伺服器或連接到我們網站的任何伺服器、電腦或資料庫，或連接到我們網站的任何其他設備或網路。您不得干擾、損壞或破壞用於提供我們網站的任何軟體，或本網站所依賴的任何第三方擁有或使用的任何設備、網路或軟體。您不得透過拒絕服務攻擊或分散式拒絕服務攻擊攻擊我們的網站。

**我們對您遭受的損失或損害的責任**

- 在法律不允許的情況下，我們不會以任何方式排除或限制我們對您的責任。
- 我們排除所有可能適用於我們網站或其上任何內容的默示條件、保證、陳述或其他條款。
- 對於因以下原因產生或與之相關的任何損失或損害，無論是否可預見，無論是合約、違反法定義務還是其他原因，我們均不對您承擔責任：
  - 使用或無法使用我們的網站；或
  - 使用或依賴我們網站上顯示的任何內容。
- 特別是，我們不對以下情況承擔責任：
  - 利潤、銷售、業務或收入的損失；
  - 業務中斷；
  - 預期儲蓄的損失；
  - 商業機會、商譽或聲譽的損失；或
  - 任何間接或後果性損失或損害。

**我們如何使用您的個人資訊**

我們只會按照我們在 <http://www.genovationfoundation.org/privacy-policy> 的隱私聲明中的規定使用您的個人資訊。

**哪些國家的法律適用於任何爭議？**

這些條款、其主題事項及其形成（以及任何非合約爭議或索賠）受香港特別行政區法律管轄。我們雙方同意香港特別行政區法院的專屬管轄權。
    `,
  },
  en: {
    // Terms of Service page
    "termsOfService.content":  `Updated 20 Nov 2025

PLEASE READ THESE TERMS OF USE CAREFULLY BEFORE USING THIS WEBSITE.

**WHAT'S IN THESE TERMS?**

These terms tell you the rules for using our website <http://www.genovationfoundation.org>

**WHO WE ARE AND HOW TO CONTACT US**

<http://www.genovationfoundation.org> is a website operated by Genovation Foundation Limited.  
Genovation Foundation is a platform, to explore solutions through three key avenues: economic subsidies, support for policy research, and cultural advocacy.  
To contact us, please email [info@genovationfoundation.org](mailto:info@genovationfoundation.org)

**BY USING OUR WEBSITE, YOU ACCEPT THESE TERMS**

By using our website, you confirm that you accept these terms and that you agree to comply with them.  
If you do not agree to these terms, you must not use our website.  
We may amend these terms from time to time. We will note the date that amendments were last made at the top of these terms, and any amendments will take effect upon posting.

**WE MAY SUSPEND OR WITHDRAW OUR WEBSITE**

We do not guarantee that our website, or any content on it, will always be available or be uninterrupted. We may suspend or withdraw or restrict the availability of all or any part of our website for business and operational reasons. We will try to give you reasonable notice of any suspension or withdrawal.

**HOW YOU MAY USE MATERIAL ON OUR WEBSITE**

We are the owner or the licensee of all intellectual property rights in our website, and in the material published on it. Those works are protected by copyright laws and treaties around the world. All such rights are reserved.  
You may print off one copy, and may download extracts, of any page(s) from our website for your personal use and you may draw the attention of others within your organisation to content posted on our website.  
You must not modify the paper or digital copies of any materials you have printed off or downloaded in any way, and you must not use any illustrations, photographs, video or audio sequences or any graphics separately from any accompanying text.  
Our status (and that of any identified contributors) as the authors of content on our website must always be acknowledged.  
You must not use any part of the content on our website for commercial purposes without obtaining a license to do so from us.  
If you print off, copy, download, share or repost any part of our website in breach of these terms, your right to use our website will cease immediately and you must, at our option, return or destroy any copies of the materials you have made (except that you are permitted to print off a copy of these terms).

**RULES ABOUT LINKING TO OUR WEBSITE**

You may link to our home page, provided you do so in a way that is fair and legal and does not damage our reputation or take advantage of it.  
You must not establish a link in such a way as to suggest any form of association, approval or endorsement on our part where none exists.  
You must not establish a link to our website in any website that is not owned by you.  
Our website must not be framed on any other website, nor may you create a link to any part of our website other than the home page.  
We reserve the right to withdraw linking permission without notice.

**WE ARE NOT RESPONSIBLE FOR WEBSITES WE LINK TO**

Where our website contains links to other websites and resources provided by third parties, these links are provided for your information only. Such links should not be interpreted as approval by us of those linked websites or information you may obtain from them.  
We have no control over the contents of those websites or resources.

**WE ARE NOT RESPONSIBLE FOR VIRUSES**

We do not guarantee that our website will be secure or free from bugs or viruses.  
You are responsible for configuring your information technology, computer programs and platform to access our website. You should use your own virus protection software.

**YOU MUST NOT INTRODUCE VIRUSES**

You must not misuse our website by knowingly introducing viruses, trojans, worms, logic bombs or other material that is malicious or technologically harmful, or otherwise harmfully interacting with our website or any part of it. You must not attempt to gain unauthorised access to our website, the server on which our website is stored or any server, computer or database connected to our website or any other equipment or network connected with our website. You must not interfere with, damage or disrupt any software used in the provision of our website or any equipment or network or software owned or used by any third party on which this website relies in any way. You must not attack our website via a denial-of-service attack or a distributed denial-of-service attack.

**OUR RESPONSIBILITY FOR LOSS OR DAMAGE SUFFERED BY YOU**

- We do not exclude or limit in any way our liability to you where it would be unlawful to do so.
- We exclude all implied conditions, warranties, representations or other terms that may apply to our website or any content on it.
- We will not be liable to you for any loss or damage, whether in contract, breach of statutory duty, or otherwise, even if foreseeable, arising under or in connection with:
  - use of, or inability to use, our website; or
  - use of or reliance on any content displayed on our website.
- In particular, we will not be liable for:
  - loss of profits, sales, business, or revenue;
  - business interruption;
  - loss of anticipated savings;
  - loss of business opportunity, goodwill or reputation; or
  - any indirect or consequential loss or damage.

**HOW WE MAY USE YOUR PERSONAL INFORMATION**

We will only use your personal information as set out in our Privacy Statement at <http://www.genovationfoundation.org/privacy-policy>.

**WHICH COUNTRY'S LAWS APPLY TO ANY DISPUTES?**

These terms, their subject matter and their formation (and any non-contractual disputes or claims) are governed by the laws of Hongkong SAR. We both agree to the exclusive jurisdiction of the courts of Hongkong SAR.
    `,
  }
};

